<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <md-card class="search-area">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            기본 정보
          </h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <tr>
              <th star>정규신청기간</th>
                <td>
                  <div class="inline-flex">
                    <input type="text" v-model="query.regularApplyFrom" ref="regularApplyFrom" required v-mask-date-time maxlength="12" class="w110">
                    <span>~</span>
                    <input type="text" v-model="query.regularApplyTo" ref="regularApplyTo" required v-mask-date-time maxlength="12" class="w110">
                  </div>
                </td>
              <th star>신청학기</th>
              <td>
                <select v-model="query.semesterCd" name="semesterCd">
                  <option value="">선택</option>
                  <option v-for="item in semesterCdList" :key="item.code" :label="item.codeNm" :value="item.code">
                    {{ item }}
                  </option>
                </select>
              </td>
              <th star>비정규신청</th>
              <td>
                <label><input type="radio" v-model="query.irregularApplyYn" name="irregularApplyYn" value="Y">신청 가능</label>
                <label><input type="radio" v-model="query.irregularApplyYn" name="irregularApplyYn" value="N">신청 불가능</label>
              </td>
              <th>비밀번호</th>
              <td><input type="text" v-model="query.password"></td>
            </tr>
          </table>
        </md-card-content>

        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="saveSchaApplyStatus"><md-icon>check</md-icon>저 장</md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import Swal from "sweetalert2";
import moment from "moment";

export default {
  components: {
  },
  computed: {
  },
  created() {
    this.getSemesterCdList();
    this.getSchaApplyStatus();
  },
  data() {
    return {
      query : {
        regularApplyYn : null,
        regularApplyFrom : '',
        regularApplyTo : '',
        semesterCd : '',
        irregularApplyYn : null,
        password : null,
        insertDate : null
      },
      semesterCdList:[]
    }
  },
  methods: {
    getSemesterCdList (){
      kuaaFnc.fncSemesterCodes(null,res => {
        this.semesterCdList = res.data.data.contents;
      });
    },
    getSchaApplyStatus (){
      let modalOptions = kuaaFnc.getSwalModaloptions();

      kuaaApi.sendServer(
        URL_CONST.GET_SCHA_APPLY_STATUS,
        {},
        "post",
        response => {
          if (response.data.result){
            this.query = response.data.data.contents[0];
          } else {
            modalOptions.html = `조회 실패 하였습니다.`;
            Swal.fire(modalOptions);
          }
        }
      );
    },

    saveSchaApplyStatus (){
      let from = this.query.regularApplyFrom.replace(/[^0-9]/g, "");
      let to = this.query.regularApplyTo.replace(/[^0-9]/g, "");

      let modalOptions = null;
      if(!from){
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: '정규신청 시작일시는 필수입니다'
        });
        Swal.fire(modalOptions);
        this.$refs.regularApplyFrom.focus();
        return false;
      }else{
        if(!moment(from, 'YYYYMMDDHHmm', true).isValid()){
          modalOptions = kuaaFnc.getSwalModaloptions({
            html: '정규신청 시작일시를 정확히 입력해 주세요<br>예)202101010900(2021년 1월 1일 18:00)'
          });
          Swal.fire(modalOptions);
          this.$refs.regularApplyFrom.focus();
          return false;
        }
      }

      if(!to){
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: '정규신청 종료일시는 필수입니다.'
        });
        Swal.fire(modalOptions);
        this.$refs.regularApplyTo.focus();
        return false;
      }else{
        if(!moment(to, 'YYYYMMDDHHmm', true).isValid()){
          modalOptions = kuaaFnc.getSwalModaloptions({
            html: '정규신청 종료일시를 정확히 입력해 주세요.<br>예)202103311800(2021년 3월 31일 18:00)'
          });
          Swal.fire(modalOptions);
          this.$refs.regularApplyTo.focus();
          return false;
        }
      }

      if(from > to){
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: '정규신청 기간을 다시 확인해 주세요'
        });
        Swal.fire(modalOptions);
        return false;
      }

      modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "저장 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        this.query.regularApplyFrom = from;
        this.query.regularApplyTo = to;

        if (result.value) {
          kuaaApi.sendServer(
            URL_CONST.UPDATE_SCHA_APPLY_STATUS,
            this.query,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `저장 되었습니다.`;
                Swal.fire(modalOptions);
                this.getSchaApplyStatus();
              } else {
                modalOptions.html = `저장 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });
    }
  }
}
</script>

<style scoped>
  input[type=password]{
    width: 100%;
    height: 28px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #bbb;
    padding: 4px 5px;
    background-color: #f6f6f6;
    line-height: 1em;
  }
</style>